<template>
  <div class="promo-design-group">
    <template
      v-if="!(isBanner && ['ios', 'tv_os', 'android_os', 'android_tv'].includes(model.device_type))"
    >
      <div>
        <div class="promo-all-buttons-inputs">
          <div class="grid grid-cols-2 gap-x-2 gap-y-4">
            <v-text-field
              v-model.trim="localizedAction('rf_retention_button1_text').rf_retention_button1_text"
              variant="outlined"
              density="compact"
              persistentPlaceholder
              label="Button 1 Text"
              :disabled="currentTranslations.hasOwnProperty('rf_retention_button1_text')"
              name="confirm-button"
              placeholder="e.g.: Sign me up"
              hideDetails
              bgColor="#ffffff"
            ></v-text-field>
            <v-text-field
              v-model.trim="actions.button1_bg_color"
              hideDetails
              variant="outlined"
              density="compact"
              persistentPlaceholder
              label="Button 1 Color"
              name="background_color"
              placeholder="e.g.: #336699"
              bgColor="#ffffff"
              @blur="actions.button1_bg_color = extendHex(actions.button1_bg_color)"
            ></v-text-field>
            <v-text-field
              v-model.trim="actions.button1_text_color"
              variant="outlined"
              density="compact"
              persistentPlaceholder
              label="Button 1 Text Color"
              name="confirm-button-text-color"
              placeholder="e.g.: #FFFFFF"
              hideDetails
              bgColor="#ffffff"
              @blur="actions.button1_text_color = extendHex(actions.button1_text_color)"
            ></v-text-field>
            <v-text-field
              v-if="isEmail(model)"
              v-model.trim="actions.rf_email_button_radius"
              variant="outlined"
              density="compact"
              persistentPlaceholder
              label="Radius"
              placeholder="e.g.: 10px"
              hideDetails
              bgColor="#ffffff"
            ></v-text-field>
            <v-text-field
              v-if="isModal && model.device_type !== 'web'"
              v-model.trim="actions.button1_highlight_color"
              hideDetails
              variant="outlined"
              density="compact"
              persistentPlaceholder
              label="Button Text Highlight"
              name="confirm-button-text-highlight"
              placeholder="e.g.: #FFFF00"
              bgColor="#ffffff"
              @blur="actions.button1_highlight_color = extendHex(actions.button1_highlight_color)"
            ></v-text-field>
            <v-text-field
              v-if="isInterstitialOrPopUp"
              v-model.trim="actions.button1_focus_bg_color"
              variant="outlined"
              density="compact"
              persistentPlaceholder
              label="Button 1 Focus Color"
              name="confirm-button-focus-color"
              placeholder="e.g.: #FFFFFF"
              hideDetails
              class="flex-1!"
              bgColor="#ffffff"
              @blur="actions.button1_focus_bg_color = extendHex(actions.button1_focus_bg_color)"
            ></v-text-field>
          </div>
        </div>
        <template v-if="tvInterstitial || isWebInterstitial">
          <RfSwitch
            v-model="actions.button_absolute_position"
            title="Absolute positioning for all buttons"
            trueValue="true"
            falseValue="false"
            class="col-span-2 mt-3 mr-auto ml-0 flex-row-reverse"
          />
          <RfRetentionButtonsAdditionalStyle
            v-model:width="actions.button1_width"
            v-model:height="actions.button1_height"
            v-model:positionX="actions.button1_position_x"
            v-model:positionY="actions.button1_position_y"
            :isWeb="isWeb"
          />
        </template>
        <div>
          <RfFadeTimer
            v-if="webPopup"
            v-model:fadeTimer="actions.rf_settings_delay_fadein_seconds"
            title="Fadein Timer"
          />
          <RfPromoInteractionInterval
            interactionType="clickButton12"
            :action="actions.rf_settings_accept_interval"
            @setIntervalAction="setIntervalAction"
          />
          <RfFadeTimer
            v-if="canHaveInteractionMessage"
            v-model:fadeTimer="actions.rf_settings_delay_fadeout_seconds"
            title="Button 1 & Button 2 Fadeout Timer"
          />
        </div>
        <div v-if="isWebOrCustomInline || isModal" class="rf-optional-button-configs">
          <v-checkbox
            v-model="actions.rf_settings_confirm_button_2_enabled"
            label="Button 2"
            hideDetails
            trueValue="true"
            falseValue="false"
          />
          <div
            v-if="`${actions.rf_settings_confirm_button_2_enabled}` === 'true'"
            class="secondary-btn-opts allow-decline-ct"
          >
            <div class="grid grid-cols-2 gap-x-2 gap-y-4">
              <v-text-field
                v-model.trim="
                  localizedAction('rf_retention_button2_text').rf_retention_button2_text
                "
                variant="outlined"
                density="compact"
                persistentPlaceholder
                label="Button 2 Text"
                :disabled="currentTranslations.hasOwnProperty('rf_retention_button2_text')"
                name="confirm-button2"
                placeholder="e.g.: Add to list"
                hideDetails
                bgColor="#ffffff"
              />
              <v-text-field
                v-model.trim="actions.button2_bg_color"
                hideDetails
                variant="outlined"
                density="compact"
                persistentPlaceholder
                label="Button 2 Color"
                placeholder="e.g.: #336699"
                bgColor="#ffffff"
                @blur="actions.button2_bg_color = extendHex(actions.button2_bg_color)"
              ></v-text-field>
              <v-text-field
                v-model.trim="actions.button2_text_color"
                variant="outlined"
                density="compact"
                persistentPlaceholder
                label="Button 2 Text Color"
                name="confirm-button-2-text-color"
                placeholder="e.g.: #FFFFFF"
                hideDetails
                bgColor="#ffffff"
                @blur="actions.button2_text_color = extendHex(actions.button2_text_color)"
              ></v-text-field>
              <v-text-field
                v-if="isModal && model.device_type !== 'web'"
                v-model.trim="actions.button2_highlight_color"
                hideDetails
                variant="outlined"
                density="compact"
                persistentPlaceholder
                label="Button 2 Text Highlight"
                name="confirm-button-2-text-highlight"
                placeholder="e.g.: #FFFF00"
                bgColor="#ffffff"
                @blur="actions.button2_highlight_color = extendHex(actions.button2_highlight_color)"
              ></v-text-field>
              <v-text-field
                v-if="isInterstitialOrPopUp"
                v-model.trim="actions.button2_focus_bg_color"
                variant="outlined"
                density="compact"
                persistentPlaceholder
                label="Button 2 Focus Color"
                name="confirm-button-2-focus-color"
                placeholder="e.g.: #FFFFFF"
                hideDetails
                class="flex-1!"
                bgColor="#ffffff"
                @blur="actions.button2_focus_bg_color = extendHex(actions.button2_focus_bg_color)"
              ></v-text-field>
            </div>
            <RfRetentionButtonsAdditionalStyle
              v-if="tvInterstitial || isWebInterstitial"
              v-model:width="actions.button2_width"
              v-model:height="actions.button2_height"
              v-model:positionX="actions.button2_position_x"
              v-model:positionY="actions.button2_position_y"
              prefix="Button 2"
              :isWeb="isWeb"
            />
          </div>
        </div>
        <div v-if="isWebOrCustomInline || isModal" class="rf-optional-button-configs">
          <v-checkbox
            v-model="actions.rf_settings_cancel_button_enabled"
            label="Button 3"
            trueValue="true"
            falseValue="false"
            hideDetails
          />
          <div
            v-if="`${actions.rf_settings_cancel_button_enabled}` === 'true'"
            class="allow-decline-ct"
          >
            <div class="grid grid-cols-2 gap-x-2 gap-y-4">
              <v-text-field
                v-model.trim="
                  localizedAction('rf_retention_button3_text').rf_retention_button3_text
                "
                variant="outlined"
                density="compact"
                persistentPlaceholder
                label="Button 3 Text"
                :disabled="currentTranslations.hasOwnProperty('rf_retention_button3_text')"
                name="cancel-button"
                hideDetails
                placeholder="e.g.: No, thanks"
                bgColor="#ffffff"
              ></v-text-field>
              <v-text-field
                v-model.trim="actions.button3_bg_color"
                hideDetails
                variant="outlined"
                density="compact"
                persistentPlaceholder
                label="Button 3 Color"
                name="b3_background_color"
                placeholder="e.g.: #336699"
                bgColor="#ffffff"
                @blur="actions.button3_bg_color = extendHex(actions.button3_bg_color)"
              ></v-text-field>
              <v-text-field
                v-model.trim="actions.button3_text_color"
                variant="outlined"
                density="compact"
                persistentPlaceholder
                label="Button 3 Text Color"
                name="cancel-button-text-color"
                placeholder="e.g.: #FFFFFF"
                hideDetails
                bgColor="#ffffff"
                @blur="actions.button3_text_color = extendHex(actions.button3_text_color)"
              ></v-text-field>
              <v-text-field
                v-if="isModal && model.device_type !== 'web'"
                v-model.trim="actions.button3_highlight_color"
                hideDetails
                variant="outlined"
                density="compact"
                persistentPlaceholder
                label="Button 3 Text Highlight"
                name="cancel-button-text-highlight"
                placeholder="e.g.: #FFFF00"
                bgColor="#ffffff"
              ></v-text-field>
              <v-text-field
                v-if="isInterstitialOrPopUp"
                v-model.trim="actions.button3_focus_bg_color"
                variant="outlined"
                density="compact"
                persistentPlaceholder
                label="Button 3 Focus Color"
                name="cancel-button-focus-color"
                placeholder="e.g.: #FFFFFF"
                hideDetails
                class="flex-1!"
                bgColor="#ffffff"
                @blur="actions.button3_focus_bg_color = extendHex(actions.button3_focus_bg_color)"
              ></v-text-field>
            </div>
            <RfPromoInteractionInterval
              interactionType="clickButton3"
              :action="actions.rf_settings_decline_interval"
              @setIntervalAction="setIntervalAction"
            />
            <RfFadeTimer
              v-if="canHaveInteractionMessage"
              v-model:fadeTimer="actions.button3_delay_fadeout_seconds"
              title="Button 3 Fadeout Timer"
            />
            <RfRetentionButtonsAdditionalStyle
              v-if="tvInterstitial || isWebInterstitial"
              v-model:width="actions.button3_width"
              v-model:height="actions.button3_height"
              v-model:positionX="actions.button3_position_x"
              v-model:positionY="actions.button3_position_y"
              prefix="Button 3"
              :isWeb="isWeb"
            />
          </div>
        </div>
      </div>
      <div v-if="isInterstitialOrPopUp" class="mt-4">
        <template
          v-if="
            (isInterstitial &&
              [DefaultDeviceOptions.android_os.value, DefaultDeviceOptions.ios.value].includes(
                model.device_type,
              )) ||
            supportsPopUpButtonLayout(model, appsStore.app?.flags?.native_popup_button_layout)
          "
        >
          <v-text-field
            v-model.trim="actions.button_width_percent"
            variant="outlined"
            density="compact"
            persistentPlaceholder
            label="Button width (percent)"
            class="mt-8"
            placeholder="e.g.: 85"
            type="number"
            hideDetails
            bgColor="#ffffff"
          ></v-text-field>
          <v-text-field
            v-model.trim="actions.button_width"
            variant="outlined"
            density="compact"
            persistentPlaceholder
            label="Button width (pixels)"
            class="mt-8"
            placeholder="e.g.: 10"
            type="number"
            hideDetails
            bgColor="#ffffff"
          ></v-text-field>
          <v-text-field
            v-model.trim="actions.button_height"
            variant="outlined"
            density="compact"
            persistentPlaceholder
            label="Button height (pixels)"
            class="mt-8"
            placeholder="e.g.: 10"
            type="number"
            hideDetails
            bgColor="#ffffff"
          ></v-text-field>
          <v-text-field
            v-model.trim="actions.button_bottom_padding"
            variant="outlined"
            density="compact"
            persistentPlaceholder
            label="Button bottom padding"
            class="my-8"
            placeholder="e.g.: 10"
            type="number"
            hideDetails
            bgColor="#ffffff"
          ></v-text-field>
        </template>
        <v-text-field
          v-if="supportsPopUpButtonFontSize(model)"
          v-model="actions.rf_retention_button_font_size"
          variant="outlined"
          density="compact"
          label="Button Font Size"
          min="0"
          persistentPlaceholder
          hideDetails
          placeholder="Enter button font size"
          class="mb-4"
        />
        Button Border
        <div class="mt-2 flex items-center justify-between gap-2">
          <RfInputWithMeasures
            v-model="buttonBorderRadius"
            :measures="[NONE_MEASURE, ...DEVICES_MEASURES]"
            label="Radius"
          />
          <RfInputWithMeasures
            v-model="buttonBorderWidth"
            :measures="[DEVICES_MEASURES]"
            label="Width"
          />
          <RfMenu hideIcon minFit preset="promptStatus" class="w-20 shrink-0 *:w-full">
            <template #activator>
              <v-text-field
                v-model="actions.rf_retention_button_border_color"
                variant="outlined"
                density="compact"
                persistentPlaceholder
                hideDetails
                label="Color"
                @blur="
                  actions.rf_retention_button_border_color = extendHex(
                    actions.rf_retention_button_border_color,
                  )
                "
              >
              </v-text-field>
            </template>
            <template #menu>
              <v-color-picker
                v-model.trim="actions.rf_retention_button_border_color"
                canvasHeight="110"
                dotSize="30"
                mode="hexa"
                class="window-transparency-picker w-72"
                variant="outlined"
              ></v-color-picker>
            </template>
          </RfMenu>
        </div>
      </div>
      <div
        v-if="!isDevicesPopUp && !isDeviceInterstitial && (isWebOrCustomInline || isModal)"
        class="mt-4"
      >
        <v-checkbox
          v-model="thankYouEnabled"
          label="Show confirmation message"
          :disabled="currentTranslations.hasOwnProperty('rf_retention_acceptance_text')"
          class="background-img-checkbox"
          hideDetails
        />
        <v-text-field
          v-if="thankYouEnabled"
          v-model.trim="
            localizedAction('rf_retention_acceptance_text').rf_retention_acceptance_text
          "
          :class="thankYouEnabled ? '' : 'disabled-button'"
          class="mb-3 ml-6"
          density="compact"
          persistentPlaceholder
          variant="outlined"
          required
          label="Confirmation message"
          placeholder="e.g.: Thank you!"
          :disabled="currentTranslations.hasOwnProperty('rf_retention_acceptance_text')"
          bgColor="#ffffff"
          hideDetails
        />
        <p
          v-if="
            canHaveInteractionMessage &&
            thankYouEnabled &&
            localizedAction('rf_retention_acceptance_text').rf_retention_acceptance_text &&
            !Number(actions.rf_settings_delay_fadeout_seconds)
          "
          class="text-red-1 mb-3 ml-7 text-xs"
        >
          Set "Button 1 & Button 2 Fadeout Timer" above to a non-zero value so this message can be
          seen.
        </p>
      </div>
      <div v-if="canHaveInteractionMessage" class="mt-4">
        <v-checkbox
          v-model="declineTextEnabled"
          label="Show decline message"
          :disabled="currentTranslations.hasOwnProperty('rf_retention_decline_text')"
          class="background-img-checkbox"
          hideDetails
        />
        <v-text-field
          v-if="declineTextEnabled"
          v-model.trim="localizedAction('rf_retention_decline_text').rf_retention_decline_text"
          :class="declineTextEnabled ? '' : 'disabled-button'"
          class="mb-4 ml-6"
          density="compact"
          persistentPlaceholder
          variant="outlined"
          required
          label="Decline message"
          placeholder="e.g.: We are sorry to hear that."
          :disabled="currentTranslations.hasOwnProperty('rf_retention_decline_text')"
          bgColor="#ffffff"
          hideDetails
        />
        <p
          v-if="
            declineTextEnabled &&
            localizedAction('rf_retention_decline_text').rf_retention_decline_text &&
            !Number(actions.button3_delay_fadeout_seconds)
          "
          class="text-red-1 mb-3 ml-7 text-xs"
        >
          Set "Button 3 Fadeout Timer" above to a non-zero value so this message can be seen.
        </p>
      </div>
    </template>
    <div v-if="showCloseOptions && !tvInterstitial">
      <v-checkbox
        v-model="actions.rf_settings_close_button_enabled"
        label="Allow close"
        trueValue="true"
        falseValue="false"
        class="promotion-closeBtn-checkbox"
        hideDetails
      />
      <v-checkbox
        v-if="isBanner"
        v-model="actions.rf_settings_click_outside_close_enabled"
        trueValue="true"
        falseValue="false"
        label="Click outside to close"
        class="promotion-closeBtn-checkbox"
        hideDetails
      />
    </div>
    <div
      v-if="
        `${actions.rf_settings_close_button_enabled}` === 'true' ||
        `${actions.rf_settings_click_outside_close_enabled}` === 'true'
      "
      :class="{ 'mt-7': tvInterstitial }"
    >
      <div class="-mt-2 mb-4 ml-6">
        <RfPromoInteractionInterval
          interactionType="dismiss"
          :action="actions.rf_settings_dismiss_interval"
          @setIntervalAction="setIntervalAction"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RfPromoInteractionInterval from "@/components/RfPromotions/RfPromoInteractionInterval.vue";
import LanguagePreviewMixin from "@/utils/LanguagePreviewMixin";
import RfFadeTimer from "@/components/RfPathCreate/RfRetentionActions/RfFadeTimer.vue";
import {
  isEmail,
  supportsPopUpButtonFontSize,
  supportsPopUpButtonLayout,
} from "@/utils/prompts/promptHelpers";
import { useAppsStore } from "@/pinia/appsStore";
import RfMenu from "@/components/menus/RfMenu.vue";
import { DEVICES_MEASURES, NONE_MEASURE, useCSSProperty } from "@/utils/composables/useCSSProperty";
import { PromptTypes } from "@/utils/constants/PromoTypesConstants";
import { DefaultDeviceOptions } from "@/utils/constants/DevicesConstants";
import RfRetentionButtonsAdditionalStyle from "@/components/RfPathCreate/RfRetentionActions/RfRetentionButtonsAdditionalStyle.vue";
import RfInputWithMeasures from "@/components/legacy/RfInputWithMeasuresLegacy.vue";
import RfSwitch from "@/components/inputs/RfSwitch.vue";
import { ref } from "vue";
import { extendHex } from "@/utils/colorHelpers";

export default {
  name: "RfRetentionButtons",
  components: {
    RfPromoInteractionInterval,
    RfFadeTimer,
    RfMenu,
    RfRetentionButtonsAdditionalStyle,
    RfInputWithMeasures,
    RfSwitch,
  },
  mixins: [LanguagePreviewMixin],
  props: {
    actions: Object,
    model: Object,
    showCloseOptions: { type: Boolean, default: false },
    isCustomDevicesEnabled: { type: Boolean, default: false },
    additionalButtonVariables: { type: Boolean, default: false },
  },
  setup: props => {
    const appsStore = useAppsStore();
    const { variable: buttonBorderRadius } = useCSSProperty(
      () => props.actions,
      "rf_retention_button_border_radius",
      { canBeEmpty: true },
    );
    const { variable: buttonBorderWidth } = useCSSProperty(
      () => props.actions,
      "rf_retention_button_border_thickness",
    );

    return {
      appsStore,
      isEmail,
      supportsPopUpButtonFontSize,
      supportsPopUpButtonLayout,
      buttonBorderRadius,
      buttonBorderWidth,
      DEVICES_MEASURES,
      NONE_MEASURE,
      DefaultDeviceOptions,
      thankYouEnabled: ref(false),
      declineTextEnabled: ref(false),
      extendHex,
    };
  },
  computed: {
    isInline() {
      return ["tile", "horizontal", "vertical"].indexOf(this.model.path_type) > -1;
    },
    isWebOrCustomInline() {
      return this.isInline && (this.model.device_type === "web" || this.isCustomDevicesEnabled);
    },
    isModal() {
      return (
        [
          "retention_modal",
          "invisible",
          "interstitial",
          "video",
          "widget",
          "bottom_banner",
        ].indexOf(this.model.path_type) > -1
      );
    },
    isWeb() {
      return this.model.device_type === DefaultDeviceOptions.web.value;
    },
    canHaveInteractionMessage() {
      return this.isModal && this.isWeb;
    },
    webPopup() {
      return this.model.path_type === "retention_modal" && this.isWeb;
    },
    isWebInterstitial() {
      return this.isInterstitial && this.isWeb;
    },
    isInterstitialOrPopUp() {
      return [PromptTypes.interstitial.value, PromptTypes.retention_modal.value].includes(
        this.model.path_type,
      );
    },
    isInterstitial() {
      return this.model.path_type === PromptTypes.interstitial.value;
    },
    tvInterstitial() {
      return (
        this.isInterstitial &&
        [
          DefaultDeviceOptions.roku_os.value,
          DefaultDeviceOptions.android_tv.value,
          DefaultDeviceOptions.tv_os.value,
        ].includes(this.model.device_type)
      );
    },
    isBanner() {
      return this.model.path_type === "bottom_banner";
    },
    isDeviceInterstitial() {
      return (
        this.isInterstitial &&
        [
          DefaultDeviceOptions.android_os.value,
          DefaultDeviceOptions.android_tv.value,
          DefaultDeviceOptions.tv_os.value,
          DefaultDeviceOptions.ios.value,
          DefaultDeviceOptions.roku_os.value,
        ].includes(this.model.device_type)
      );
    },
    isDevicesPopUp() {
      return (
        this.model.path_type === PromptTypes.retention_modal.value &&
        [
          DefaultDeviceOptions.android_os.value,
          DefaultDeviceOptions.android_tv.value,
          DefaultDeviceOptions.ios.value,
          DefaultDeviceOptions.tv_os.value,
        ].includes(this.model.device_type)
      );
    },
  },
  watch: {
    thankYouEnabled(to) {
      if (!to) {
        if (!this.isLocalized) {
          this.actions.rf_retention_acceptance_text = null;
          this.$emit("forceRender");
        }
      }
    },
    declineTextEnabled(to) {
      if (!to) {
        if (!this.isLocalized) {
          this.actions.rf_retention_decline_text = null;
          this.$emit("forceRender");
        }
      }
    },
  },
  mounted() {
    this.thankYouEnabled = this.model.id
      ? !!this.readOnlyActions.rf_retention_acceptance_text
      : true;
    this.declineTextEnabled = this.model.id
      ? !!this.readOnlyActions.rf_retention_decline_text
      : true;
  },
  methods: {
    localizedAction(key) {
      return this.currentTranslations.hasOwnProperty(key) ? this.previewActions : this.actions;
    },
    setIntervalAction(value, type) {
      this.actions[`rf_settings_${type}_interval`] = value;
    },
  },
};
</script>
<style scoped>
.disabled-button {
  pointer-events: none;
  opacity: 0.5;
}
.rf-optional-button-configs {
  padding: 15px 0 0;
}
.hide-buttons-opt {
  display: none;
}
</style>
